import Pencil from './src/pencil-combined';
export default Pencil;